import React from 'react';
import * as S from './styles';

type Props = React.LiHTMLAttributes<HTMLLIElement> & {
  open: boolean;
  iconName: string;
  linkTo?: string;
  isCurrentRoute: boolean;
}

export const SidebarItem = React.forwardRef<HTMLLIElement, Props>(({ children, open, iconName, linkTo = '', isCurrentRoute, ...props }: React.PropsWithChildren<Props>, forwardRef) => {
  const content = (
    <>
      <S.SidebarIcon $currentRoute={isCurrentRoute} icon={iconName} height="1.8rem" />
      <S.SidebarTitle $currentRoute={isCurrentRoute} $open={open}>{children}</S.SidebarTitle>
    </>
  );

  const navItemContent = (
    <S.Sidebar
      $currentRoute={isCurrentRoute}
      {...props}
      ref={forwardRef}
    >
      {content}
    </S.Sidebar>
  );

  return linkTo ? (
    <S.StyledLink to={linkTo}>
      {navItemContent}
    </S.StyledLink>
  ) : (
    navItemContent
  );
});
